'use client';
import { useState, useEffect } from 'react';
import React from 'react';

export default function SpAttributeOption({
  attr,
  filters,
  options,
  matches,
  onVariationChange,
  attrIndex,
}) {
  const [selectedValue, setSelectedValue] = useState('');

  useEffect(() => {
    const filterValue = filters.find((filter) => filter.key === attr)?.value;
    if (filterValue) {
      setSelectedValue(filterValue);
    } else {
      setSelectedValue(''); // Reset if no match
    }
  }, [filters, attr]);

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    const selectedOption = options.find(
      (option) => option.value === selectedValue && option.key === attr
    );

    if (selectedOption) {
      onVariationChange(selectedOption.key, selectedOption.value);
      setSelectedValue(selectedOption.value);
    }
  };

  return (
    <div className="items-center flex">
      <div className="md:text-sm text-xs text-gray-400 pl-2 whitespace-nowrap py-3">
        <span>{attr} :</span>
      </div>

      <div className="md:text-sm text-xs text-dark-gray">
        <div className="attrSelection text-sm relative">
          <select
            onChange={handleSelectChange}
            className="pr-2.5 pl-14 py-0 rounded-md text-sm"
            value={selectedValue}
          >
            <option value="">انتخاب کنید</option>
            {options
              .filter((option) => option.key === attr)
              .map((option, index) => {
                const isDisable = () => {
                  if (attrIndex === 0) return false;
                  if (filters.length === 1 && filters[0].key === option.key)
                    return false;
                  if (filters.length > 0 && matches.includes(option.value)) {
                    return false;
                  }
                  return filters.length !== 0;
                };

                return (
                  !isDisable() && (
                    <option
                      key={index}
                      value={option.value}
                      className="cursor-pointer m-2 text-xs md:text-sm border-b border-gray-50"
                    >
                      {option.value}
                    </option>
                  )
                );
              })}
          </select>
        </div>
      </div>
    </div>
  );
}
